import { ICellRendererParams } from 'ag-grid-community'
import { MouseEvent } from 'react'
import { styled } from '@mui/material'
import { ProgressReportTableContent } from '../table/ProgressReportTable'
import { colorPalette } from '../../../../style/colorPalette'
import { WbsItemAggregateCategory } from '../../../../../domain/value-object/ProjectPlanSnapshot'

const FIELD_TO_CATEGORY: Record<string, WbsItemAggregateCategory> = {
  total: 'TOTAL',
  planned: 'PLANNED',
  completed: 'COMPLETED',
  delay: 'DELAY',
  remaining: 'REMAINING',
  preceding: 'PRECEDING',
  unplanned: 'UNPLANNED',
}

type NumericDrillDownCellRendererParams =
  ICellRendererParams<ProgressReportTableContent> & {
    onNumericCellClick?: (
      data: ProgressReportTableContent,
      anchorEl: HTMLElement,
      clickPosition: { x: number; y: number },
      aggregateType: WbsItemAggregateCategory
    ) => void
    disabled?: boolean
  }

export const NumericDrillDownCellRenderer = (
  props: NumericDrillDownCellRendererParams
) => {
  const { value, data, onNumericCellClick, disabled, colDef } = props
  const field = colDef?.field
  const aggregateType = field ? FIELD_TO_CATEGORY[field] : undefined

  const handleClick = (e: MouseEvent<HTMLDivElement>) => {
    if (disabled) return
    if (!data || !onNumericCellClick || !aggregateType) return
    onNumericCellClick(
      data,
      e.currentTarget,
      { x: e.clientX, y: e.clientY },
      aggregateType
    )
  }

  const isClickable = !disabled && !!onNumericCellClick && !!aggregateType

  return (
    <ClickableCell clickable={isClickable} onClick={handleClick}>
      {value}
    </ClickableCell>
  )
}

const ClickableCell = styled('div', {
  shouldForwardProp: prop => prop !== 'clickable',
})<{ clickable: boolean }>(({ clickable }) => ({
  width: '100%',
  height: '100%',
  boxSizing: 'border-box',
  paddingRight: '5px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  cursor: clickable ? 'pointer' : 'default',
  color: clickable ? colorPalette.skyBlue[7] : 'inherit',
  '&:hover': clickable ? { textDecoration: 'underline' } : {},
}))
